import { styled } from '@linaria/react'

export const PartnerProgramCoverDesktopSC = styled.svg`
  width: 100%;
  height: 100%;
`

export const PartnerProgramCoverMobileSC = styled.svg`
  width: 100%;
  height: 100%;
`
